export default __webpack_public_path__ + "static/media/SuperroamUK.08fadc9d.png";